import React from "react";
import Layout from "../layout/layout";

const PrivateArea = () => {
  return (
    <Layout>
      <h1>Contenido principal de la página de inicio</h1>
    </Layout>
  );
};

export default PrivateArea;
